var map = {
	"./DmitriArrow.json": [
		638,
		20
	],
	"./IceSpike1.json": [
		639,
		21
	],
	"./IceSpike2.json": [
		640,
		22
	],
	"./IceSpike3.json": [
		641,
		23
	],
	"./SpikeImpactDust.json": [
		642,
		24
	],
	"./SpikeImpactParticle.json": [
		643,
		25
	],
	"./StompImpact.json": [
		644,
		26
	],
	"./StompImpactDust.json": [
		645,
		27
	],
	"./StompImpactParticle.json": [
		646,
		28
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1181;
module.exports = webpackAsyncContext;